<template>
    <div>
        <div class="form-container">
            <div class="form-title margin-b20">表2-{{supplierType === '101' ? '生产能力保障审查' : '服务保障能力审查'}}</div>
            <div class="flex">
                <UploadGetData
                        :limit="1"
                        :fileSize="2"
                        :uploadUrl="produceAbilityImport"
                        :verify="true"
                        @getFileInfo="getTableFourInfo"
                        :isOnlyXlsx="true"
                />
                <eui-btn type="weak"  width="88" v-debounce="produceAbilityDown">下载模板</eui-btn>
            </div>

            <div v-for="(item,index) in evaluationProduceAbilityList" :key="index">
                <div class="production-review-box" :class="{'red-border': item.showWord && !item.show}">
                    <div class="production-review-top">
                        <div class="production-review-left flex-all-center">
                            <div class="project-box">评审项目：
                                <e-tooltip :content="item.ability" :set-length="8" style="display: inline-block"/>
                            </div>
                            <div :class="{'red-border': item.showWord}">分值：
                                <el-input v-model="item.score" style="width: 60px;height: 30px;"
                                          @input="item.score = item.score.replace( /[^0-9.]/g, '' )"
                                          oninput="if(!/^[0-9]+$/.test(value)) value=value.replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3');if(value>100)value=100;if(value<0)value=null;if((value[0] == 0 && value[1] > 0) || value == '00')value=value.slice(1);"
                                          @change="handleOneLevelScore"></el-input>
                            </div>
                        </div>
                        <div class="production-review-right flex">
                            <div class="margin-r10" @click="addTwo(index)">新增二级指标</div>
                            <div class="show-box" @click="handleShow(index)">展开
                                <eui-icon class="data-icon" :icon="item.show ? 'eicon-arrow-down' : 'eicon-arrow-up'"
                                          style="color: #0064C8"/>
                            </div>
                        </div>
                    </div>
                    <div class="production-review-bottom" v-if="item.showCenterTip">
                        二级指标分值总计与一级项指标分值不相等，请核对并修改</div>
                </div>
                <div v-if="item.show">
                    <div v-for="(reviewItem,reviewIndex) in item.productionReviewDetailData" :key="reviewIndex">
                        <!--表头-->
                        <div class="common-box table-title">
                            <div class="first-item border-right-item">二级指标</div>
                            <div class="second-item border-right-item">三级指标</div>
                            <div class="third-item border-right-item">评审标准</div>
                            <div class="four-item border-right-item">分值</div>
                            <div class="five-item">操作</div>
                        </div>
                        <!--表格 第二行内容-->
                        <div class="handle-box">
                            <div class="handle-left">
                                <el-input v-model="reviewItem.ability" placeholder="请输入二级指标名称"
                                          style="padding: 10px"></el-input>
                                <div class="flex-all-center" :class="{'red-border': item.showCenterTip}">分值：
                                    <el-input v-model="reviewItem.score" placeholder="请输入分值" style="width: 144px;"
                                              oninput="if(!/^[0-9]+$/.test(value)) value=value.replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3');if(value>100)value=100;if(value<0)value=null;if((value[0] == 0 && value[1] > 0) || value == '00')value=value.slice(1);"
                                              @input=" reviewItem.score = reviewItem.score.replace( /[^0-9.]/g, '' )"
                                              @change="handleTwoOrThreeLevelScore(index,reviewIndex)"></el-input>
                                </div>
                                <div class="production-review-bottom" style="text-align: start;margin-left: 10px" v-if="reviewItem.showDetailTip">
                                    二级指标分值总计与三级项指标分值不相等，请核对并修改</div>
                            </div>
                            <div class="handle-right">
                                <div v-for="(detailItem,detailIndex) in reviewItem.detailData" :key="detailIndex">
                                    <div class="right-top flex-all-center" :style="{ height: reviewItem.detailData.length ===1 && reviewItem.showDetailTip ? '72px' : '50px' }">
                                        <div class="handle-second">
                                            <el-input v-model="detailItem.ability" placeholder="请输入三级指标"
                                                      style="padding: 10px"></el-input>
                                        </div>
                                        <div class="handle-third">
                                            <el-input v-model="detailItem.standard" placeholder="请输入评审标准"
                                                      style="padding: 10px"></el-input>
                                        </div>
                                        <div class="handle-four" :class="{'red-border': reviewItem.showDetailTip}">
                                            <el-input v-model="detailItem.score" style="padding: 10px"
                                                      oninput="if(!/^[0-9]+$/.test(value)) value=value.replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3');if(value>100)value=100;if(value<0)value=null;if((value[0] == 0 && value[1] > 0) || value == '00')value=value.slice(1);"
                                                      @input="detailItem.score = detailItem.score.replace( /[^0-9.]/g, '' )"
                                                      @change="handleTwoOrThreeLevelScore(index,reviewIndex)"></el-input>
                                        </div>
                                        <div class="handle-five del-box flex-all-center">
                                            <div :style="{ color: item.productionReviewDetailData.length === 1 && reviewItem.detailData.length === 1 ? '#999' : '#0064C8' }"
                                                 class="margin-r10"
                                                 @click="dealTreeLevel(index,reviewIndex,detailIndex)">删除
                                            </div>
                                            <div :style="{ color: detailItem.length === 1 ? '#999' : '#0064C8' }" @click="clearData(index,reviewIndex,detailIndex)">清空
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="add-box">
                                    <div class="table-add" @click="addThree(index,reviewIndex)">
                                        <eui-icon class="data-icon" icon="eicon-add"/>
                                        三级指标
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="add-box border-box">
                        <div class="table-add" @click="addTwo(index)">
                            <eui-icon class="data-icon" icon="eicon-add"/>
                            二级指标
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="flex-sb">
            <div>
                <eui-btn type="weak" @click="backStep">上一步</eui-btn>
            </div>
            <div>
                <eui-btn type="weak" style="margin-right: 30px" v-debounce="() =>tempSaveOrConfirmNext(0)">保 存</eui-btn>
                <eui-btn type="primary" v-debounce="() =>tempSaveOrConfirmNext(1)">下一步</eui-btn>
            </div>
        </div>
    </div>
</template>

<script>
    import api from '@/modules/projectA/api/ESorganization/index';
    import eTooltip from "../../../../components/common/e-tooltip";
    import UploadGetData from './uploadGetData.vue';
    import utils from '@/modules/projectA/utils/utils';
    export default {
        name: "productionReview",
        components:{eTooltip,UploadGetData},
        props: {
            supplierType: {
                type: String,
                default: ''
            },
            evaluationId: {
                type: Number,
                default: 1687
            }
        },
        data() {
            return {
                produceAbilityImport:'',
                nextStepsOne:false,//false 可以通过 不卡； true 不能通过，卡住
                nextStepsTwo:false,//false 可以通过 不卡； true 不能通过，卡住
                nextStepsThree:false,//false 可以通过 不卡； true 不能通过，卡住
                input: '',
                baseDataInfo: {},
                evaluationProduceAbilityList: [],
                emptyData: [{
                    ability: "",
                    standard: "",
                    level: '',
                    nodeId: "",
                    parentNodeId: "",
                    remark: "",
                    score: '',
                    sortNum: '',
                    showDetailTip:false,//展示 内层 数值不等
                    showCenterTip:false,
                }]
            }
        },
        methods: {
            //数组转成树
             oArrayToTree (arr) {
                let result = [];
                if (!Array.isArray(arr) || arr.length === 0) {
                    return result
                }
                let map = {};
                arr.forEach(item => map[item.nodeId] = item);
                // console.log('map:', map) // 对象 为了映射父子关系
                arr.forEach(item => {
                    // console.log(item.parentNodeId, 'item.pid')
                    //
                    const parent = map[item.parentNodeId];
                    // console.log('parent:', parent, 'map[item.pid]')
                    if(parent){
                        // (parent.children || (parent.children=[])).push(item);
                        if(parent.children) {
                            parent.children.push(item)
                        } else {
                            // 如果 parent 没有 children 属性(顶级) 则赋值为 []
                            parent.children=[]
                            // 然后push item
                            parent.children.push(item)
                        }

                    } else {
                        result.push(item);
                    }
                })
                return result
            },
            //基本资质审查 导入
            getTableFourInfo(info, index){
                let result = this.oArrayToTree(info);
                const oldKey = "children";
                const newKey1 = "productionReviewDetailData";
                const newKey2 = "detailData";

                result.forEach(item=>{
                    this.$set(item, 'show', true);//展开的设置
                    this.$set(item, 'showWord', false);//二级弹框提示
                    this.$set(item, 'showCenterTip', false);//二级红字提示
                    item.children.forEach(detailItem=>{
                        this.$set(detailItem, 'showDetailTip', false);
                        this.$set(detailItem, 'showCenterTip', false);
                        detailItem[newKey2] = detailItem[oldKey];
                        delete detailItem[oldKey];
                    })
                   item[newKey1] = item[oldKey];
                    delete item[oldKey];
                })

              this.evaluationProduceAbilityList = result;
              this.testInput();

                console.log( this.evaluationProduceAbilityList,' this.evaluationProduceAbilityList')
            },
            async produceAbilityDown(){
                const result = await api.produceAbilityDown();
                if (result.type == 'application/json') {
                    utils.fileExportResponseError(result);
                } else {
                    utils.downFile(result, '生产保障能力审查表','.xls');
                }
            },
            //处于中间位置。需要校验二级 、三级 右侧的分值
            //处理三级的 score   二级的 index ： reviewIndex
            handleTwoOrThreeLevelScore(index, reviewIndex,onlyTwo) {
                let productionReviewDetailData = this.evaluationProduceAbilityList[index].productionReviewDetailData;
                if(!onlyTwo && !Number(productionReviewDetailData[reviewIndex].score)){
                    return;
                }
                //处理二级的分值
                let threeLeftScoreArr = [];
                productionReviewDetailData.forEach(item=>{
                    if(item.score){
                        threeLeftScoreArr.push(item.score)
                    }
                })
                //每一行的 值都输入 后 校验
                if(threeLeftScoreArr.length === productionReviewDetailData.length){
                    let total = 0;
                    threeLeftScoreArr.forEach(item => {
                        total += Number(item);
                    })
                    //全有值并且 不相等 提示
                    if(total !== Number(this.evaluationProduceAbilityList[index].score)){
                        this.evaluationProduceAbilityList[index].showCenterTip = true;
                        this.nextStepsTwo = true;
                    }else{
                        this.evaluationProduceAbilityList[index].showCenterTip = false;
                        this.nextStepsTwo = false;
                    }
                }


                if(!onlyTwo){
                    let detailData = productionReviewDetailData[reviewIndex].detailData ;
                    //处理三级 右侧的分值
                    let threeRightScoreArr = [];
                    detailData.forEach(item => {
                        if(item.score){
                            threeRightScoreArr.push(item.score)
                        }
                    })
                    //每一行的 值都输入 后 校验
                    if(threeRightScoreArr.length === detailData.length){
                        let total = 0;
                        threeRightScoreArr.forEach(item => {
                            total += Number(item);
                        })
                        //全有值并且 不相等 提示
                        if(total !== Number(productionReviewDetailData[reviewIndex].score)){
                            this.evaluationProduceAbilityList[index].productionReviewDetailData[reviewIndex].showDetailTip = true;
                            this.nextStepsThree = true;
                        }else{
                            this.evaluationProduceAbilityList[index].productionReviewDetailData[reviewIndex].showDetailTip = false;
                            this.nextStepsThree = false;
                        }
                    }
                }


            },
            //处理一级的 score   nextStepsOne: false 可以通过 不卡； true 不能通过，卡住
            handleOneLevelScore() {
                let scoresArr = this.evaluationProduceAbilityList.map(item => item.score);
                let total = 0;
                scoresArr.forEach(item => {
                    total += Number(item);
                })
                if (total !== 100) {
                    this.evaluationProduceAbilityList.forEach(item => {
                        this.$set(item, 'showWord', true);
                    })
                    this.nextStepsOne = true;
                    this.$message.error('各评审项目分值总计不等于100，请核对并修改');
                } else {
                    this.evaluationProduceAbilityList.forEach(item => {
                        this.$set(item, 'showWord', false);
                        this.nextStepsOne = false;
                    })
                }
            },
            //上一步
            backStep(){
                this.$emit('getStep', 2);
            },
            //各种输入的校验
            testInput(){
                 //校验第一步数据
                 this.handleOneLevelScore();
                 if(this.nextStepsOne){
                     return false;
                 }
                let messageTip = '';
                 //是否为空、分数之和是否相等 否则 就 阻拦住  handleTwoOrThreeLevelScore   reviewIndex
                try{
                    this.evaluationProduceAbilityList.forEach((item,index)=>{

                         item.productionReviewDetailData.forEach((reviewItem,reviewIndex)=>{
                             this.handleTwoOrThreeLevelScore(index,reviewIndex);
                             //校验 二步 的 字段
                             if(!reviewItem.ability){
                                 messageTip = item.ability + '的二级指标不能为空。';
                                 console.log('111111111111111')
                                 throw Error();
                             }
                             if(!reviewItem.score){
                                 messageTip = item.ability + '的二级指标分值不能为空。';
                                 console.log('222222222222222')
                                 throw Error();
                             }
                             //校验三步的字段
                             reviewItem.detailData.forEach((detailItem,detailIndex)=>{
                                 if(!detailItem.ability){
                                     messageTip = item.ability + '的三级指标不能为空。';
                                     console.log('3333333333333333')
                                     throw Error();
                                 }
                                 if(!detailItem.standard){
                                     messageTip = item.ability + '的评价标准不能为空。';
                                     console.log('44444444444444444')
                                     throw Error();
                                 }
                                 if(!detailItem.score){
                                     messageTip = item.ability + '的三级指标分值不能为空。';
                                     console.log('555555555555555555')
                                     throw Error();
                                 }
                             })
                         });
                    })
                }catch (e) {
                    console.log(messageTip,'66666666666666')
                    if(messageTip){
                        this.$message.warning(messageTip);
                    }else{
                        messageTip = true;
                    }
                }

                console.log(messageTip,'777777777777777777')
                return messageTip ? messageTip : false;

            },
            //0 是 保存，1 是 下一步
            async tempSaveOrConfirmNext(tempSaveOrConfirmNext) {
                 if( tempSaveOrConfirmNext ===1 && (this.nextStepsTwo || this.nextStepsThree) ){
                     return false;
                 }
                 //校验数据
                if(tempSaveOrConfirmNext ===1 && this.testInput()){
                    return false;
                }

                let evaluationProduceAbilityList = this.dealData(); //处理为平级


                let params = {
                    tempSaveOrConfirmNext: tempSaveOrConfirmNext,
                    currentStep: 3,
                    evaluationCode: this.baseDataInfo.evaluationCode,
                    evaluationId: this.baseDataInfo.evaluationId,
                    evaluationProduceAbilityList: evaluationProduceAbilityList,
                }


                let res = await api.tempSaveOrConfirmNext(params);
                if (res.success) {
                    if (tempSaveOrConfirmNext === 1) {
                        this.$emit('getStep', 4);
                    } else {
                        this.$message.success('保存成功。')
                    }
                }
            },
            //处理为平级结构
            dealData() {
                let evaluationProduceAbilityList = [];
                let twoLevelNum = 0 ;
                //第一层
                this.evaluationProduceAbilityList.forEach((item,index)=>{
                    let firstNodeId = Number(index) + 1;
                    let firstObj = JSON.parse(JSON.stringify(this.emptyData[0]));
                    firstObj.ability = item.ability;
                    firstObj.standard = item.standard;
                    firstObj.level = 1;
                    firstObj.nodeId = firstNodeId;
                    firstObj.parentNodeId = 0;
                    firstObj.score = item.score;
                    firstObj.sortNum = firstNodeId;
                    evaluationProduceAbilityList.push(firstObj);
                    //第二层
                    item.productionReviewDetailData.forEach((reviewItem,reviewIndex)=>{
                        let secondNodeId = Number(reviewIndex) + 1 ;
                        twoLevelNum++;
                        let secondObj = JSON.parse(JSON.stringify(this.emptyData[0]));
                        secondObj.ability = reviewItem.ability;
                        secondObj.standard = reviewItem.standard;
                        secondObj.level = 2;
                        secondObj.nodeId = twoLevelNum +'-'+secondNodeId;
                        secondObj.parentNodeId = firstNodeId;
                        secondObj.score = reviewItem.score;
                        secondObj.sortNum = Number(firstNodeId) + Number(secondNodeId);
                        evaluationProduceAbilityList.push(secondObj);
                        //第三层
                        reviewItem.detailData.forEach((detailItem,detailIndex)=>{
                            let thirdNodeId = Number(detailIndex) + 1 ;
                            let thirdObj = JSON.parse(JSON.stringify(this.emptyData[0]));
                            thirdObj.ability = detailItem.ability;
                            thirdObj.standard = detailItem.standard;
                            thirdObj.level = 3;
                            thirdObj.nodeId = twoLevelNum +'-' + secondNodeId +'-'+ thirdNodeId;
                            thirdObj.parentNodeId =  twoLevelNum + '-' + secondNodeId;
                            thirdObj.score = detailItem.score;
                            thirdObj.sortNum = Number(firstNodeId) + Number(secondNodeId) + Number(thirdNodeId);
                            evaluationProduceAbilityList.push(thirdObj);
                        })
                    })
                })
                return evaluationProduceAbilityList;
            },
            handleShow(index) {
                this.evaluationProduceAbilityList[index].show = !this.evaluationProduceAbilityList[index].show;
            },
            addTwo(index) {
              let  emptyData = {
                    ability: "",
                    standard: "",
                    level: '',
                    nodeId: "",
                    parentNodeId: "",
                    remark: "",
                    score: '',
                    sortNum: '',
                    showDetailTip:false,//展示 内层 数值不等
                    showCenterTip:false,
                  detailData:[{
                      ability: "",
                      standard: "",
                      level: '',
                      nodeId: "",
                      parentNodeId: "",
                      remark: "",
                      score: '',
                      sortNum: '',
                      showDetailTip:false,//展示 内层 数值不等
                      showCenterTip:false,
                  }],
                }
                this.evaluationProduceAbilityList[index].productionReviewDetailData.splice(this.evaluationProduceAbilityList[index].productionReviewDetailData.length,0,emptyData);
                this.deepCloneData();
            },
            addThree(index, reviewIndex) {
                let  emptyData = {
                    ability: "",
                    standard: "",
                    level: '',
                    nodeId: "",
                    parentNodeId: "",
                    remark: "",
                    score: '',
                    sortNum: '',
                    showDetailTip:false,//展示 内层 数值不等
                    showCenterTip:false,
                }
                this.evaluationProduceAbilityList[index].productionReviewDetailData[reviewIndex].detailData.push(emptyData);
                this.deepCloneData();
            },
            deepCloneData(){
                let allData=JSON.parse(JSON.stringify(this.evaluationProduceAbilityList));
                this.evaluationProduceAbilityList = allData ;
            },
            //清空数据
            clearData(index, reviewIndex, detailIndex){
                this.evaluationProduceAbilityList[index].productionReviewDetailData[reviewIndex].detailData[detailIndex].ability = '';
                this.evaluationProduceAbilityList[index].productionReviewDetailData[reviewIndex].detailData[detailIndex].standard = '';
                this.evaluationProduceAbilityList[index].productionReviewDetailData[reviewIndex].detailData[detailIndex].score = 0;
            },
            //删除三级
            dealTreeLevel(index, reviewIndex, detailIndex) {
                //最后一个二级的 最后一个三级不能删除
                if (this.evaluationProduceAbilityList[index].productionReviewDetailData.length === 1 &&
                    this.evaluationProduceAbilityList[index].productionReviewDetailData[reviewIndex].detailData.length === 1) {
                    this.deepCloneData();
                    return false;
                }
                console.log(this.evaluationProduceAbilityList[index].productionReviewDetailData,'this.evaluationProduceAbilityList[index]')
                //其他二级 删除 最后 一个三级 二级 也删除
                if (this.evaluationProduceAbilityList[index].productionReviewDetailData.length > 1 &&
                    this.evaluationProduceAbilityList[index].productionReviewDetailData[reviewIndex].detailData.length === 1
                ) {
                    this.evaluationProduceAbilityList[index].productionReviewDetailData.splice(reviewIndex, 1);
                    this.deepCloneData();
                    this.$nextTick(() => {
                            this.handleTwoOrThreeLevelScore(index,reviewIndex,'onlyTwo');
                        }
                    )

                    return false;
                }
                this.evaluationProduceAbilityList[index].productionReviewDetailData[reviewIndex].detailData.splice(detailIndex, 1);
                this.handleTwoOrThreeLevelScore(index, reviewIndex);
                this.deepCloneData();
            },
            //增加二级指标
            dealTwoData() {
                let emptyData = JSON.parse(JSON.stringify(this.emptyData));
                emptyData[0].detailData = JSON.parse(JSON.stringify(this.emptyData));
                return JSON.parse(JSON.stringify(emptyData));
            },
            async auxiliaryStepDetail() {
                let params = {
                    currentStep: 3,
                    evaluationId: this.evaluationId,
                };
                let res = await api.auxiliaryStepDetail(params);
                if (res.success) {
                    this.baseDataInfo = res.data;
                    let evaluationProduceAbilityList = res.data.evaluationProduceAbilityList || [];

                        //未保存过的数据 放层级
                        if(evaluationProduceAbilityList[0].level === evaluationProduceAbilityList[1].level){
                            this.evaluationProduceAbilityList = evaluationProduceAbilityList;
                            //设置展开字段
                            this.evaluationProduceAbilityList.forEach(item => {
                                this.$set(item, 'productionReviewDetailData',this.dealTwoData());
                                this.$set(item, 'show', false);//展开的设置
                                this.$set(item, 'showWord', false);//二级弹框提示
                                this.$set(item, 'showCenterTip', false);//二级红字提示

                            })
                        }else{
                            this.getTableFourInfo(evaluationProduceAbilityList);
                        }
                }
            },
        },
        mounted() {
            this.auxiliaryStepDetail();

            this.produceAbilityImport = api.produceAbilityImport();
        }
    }
</script>

<style scoped lang="scss">
    .production-review-box {
        width: 100%;
        padding: 10px;
        border: 1px solid #DCDCDC;
        background-color: #F5F5F5;
        margin-top: 10px;

        .production-review-top {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .production-review-left {
                color: #666;
                font-size: 12px;

                .project-box {
                    width: 160px;
                }
            }

            .production-review-right {
                font-size: 14px;
                color: #0064C8;

                div {
                    cursor: pointer;
                }

                .show-box {
                    color: #0064C8;

                    .data-icon {
                        width: 14px;
                        height: 14px;
                    }
                }
            }
        }
    }
    .production-review-bottom {
        margin-top: 4px;
        font-size: 12px;
        color: #F0250F;
    }

    .red-border {
        border-color: #E50113;

        ::v-deep .el-input__inner {
            border-color: #E50113;
            color:#E50113 ;
        }
    }

    .common-box {
        display: flex;
        text-align: center;
        align-items: center;
        font-size: 12px;
        border: 1px solid #DCDCDC;
        height: 40px;
        background-color: #F5F5F5;
        border-top: none;
        border-bottom: none;
        color: #333;

        .border-right-item {
            height: calc(100%);
            display: flex;
            align-items: center;
            justify-content: center;
            border-right: 1px solid #DCDCDC;
        }

        .first-item {
            width: 200px;
        }

        .second-item {
            flex: 1;
        }

        .third-item {
            flex: 1.5;
        }

        .four-item {
            width: 100px;
        }

        .five-item {
            width: 80px;
        }
    }

    .handle-box {
        display: flex;
        text-align: center;
        align-items: center;
        font-size: 12px;
        border: 1px solid #DCDCDC;

        .handle-left {
            width: 200px;
        }

        .handle-right {
            width: calc(100% - 188px);
            border-left: 1px solid #DCDCDC;

            .right-top {
                display: flex;
                height: 75px;
                border-bottom: 1px solid #DCDCDC;

                .handle-second {
                    flex: 1;
                }

                .handle-third {
                    flex: 1.5;
                    border-left: 1px solid #DCDCDC;
                }

                .handle-four {
                    width: 100px;
                    border-left: 1px solid #DCDCDC;
                }

                .handle-five {
                    width: 81px;
                    line-height: 50px;
                    border-left: 1px solid #DCDCDC;
                }

                .del-box {
                    color: #0064C8;
                    cursor: pointer;
                    font-size: 12px;
                }
            }
        }
    }

    .border-box {
        border: 1px solid #DCDCDC;
        border-top: none;
    }

    .add-box {
        height: 60px;
        padding: 10px;
        background-color: #F5F5F5;

        .data-icon {
            width: 10px;
            height: 10px;
            margin-right: 10px;
        }

        .table-add {
            font-size: 16px;
            cursor: pointer;
            background-color: #fff;
            height: 40px;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }

</style>